import React, { Suspense, useEffect, useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Banner from "./Banner";
import useShots from "../../../hooks/useShots";
import useCategories from "../../../hooks/useCategories";
import useStore from "../../../store/useStore";
import useTopics from "../../../hooks/useGetTopics";
import usePlanDetails from "../../../hooks/usePlanDetails";
import { Spin } from "antd";

const TrendingSection = React.lazy(() => import("./TrendingSection"));
const MyFeedSection = React.lazy(() => import("./MyFeedSection"));
const AllNewsSection = React.lazy(() => import("./AllNewsSection"));
const TopicsSection = React.lazy(() => import("./TopicsSection"));

const HomePage: React.FC = () => {
  const { getShots } = useShots();
  const { getCategories } = useCategories();
  const { getTopics } = useTopics();
  const { tatvaShots } = useStore();
  const { getPlanDetails } = usePlanDetails();

  useEffect(() => {
    getPlanDetails();
    getShots("myFeed");
    getShots("trending");
    getShots("allNews");
    getCategories();
    getTopics();
  }, []);

  return (
    <div className="flex flex-col bg-gray-50 pb-[64px]">
      <Header />
      <Banner shots={tatvaShots.myFeed} />
      <Suspense fallback={<Spin size="large" className="flex justify-center items-center" />}>
        <TrendingSection shots={tatvaShots.trending} />
        <MyFeedSection shots={tatvaShots.myFeed} />
        <AllNewsSection shots={tatvaShots.allNews} />
        {/* <TopicsSection categories={tatvaShots.categories} /> */}
      </Suspense>
      <Footer />
    </div>
  );
};

export default HomePage;